import * as React from 'react';
import { Add } from '../../Icon/icon';
import { useActions } from '../schemaModalActions';
import { getSchema } from '../../../utils';
import { ModalGroup, ModalGroups } from '../../ModalGroup/modalGroup';
import { Icon } from 'rcd-cpp-ui/ui/icon';
import { NodeType } from '../../../enums/NodeType';
import { useSelector } from '../../../utils/useSelector';
import { ItemFieldCardWrapper } from '../ItemFieldCard/itemFieldCardWrapper';

export const hasShowHideOption = (nodeType: NodeType) =>
  nodeType == NodeType.Item;

export const PageItemFields = () => {
  const fieldsToDisplay = useSelector(s =>
    s.schemaModal?.fields?.filter(f => !f.parentField)
  );

  const canAddField = useSelector(s => {
    const workspace = s.planning?.selectedWorkspace;
    const schema = getSchema(workspace?.schemas, NodeType.Item);
    if (
      schema?.isInherited &&
      workspace.parent &&
      !workspace.props?.allowOwnCustomData
    ) {
      return false;
    }
    return true;
  });
  const { addField } = useActions();

  return (
    <ModalGroups id="manageFields">
      <ModalGroup
        label={
          <>
            Configure Fields
            {canAddField && (
              <div className="add-more">
                <Icon onClick={addField}>
                  <Add /> Add
                </Icon>
              </div>
            )}
          </>
        }
        text="Please use this tab to add/remove all meta data/fields that you want to associate with this item."
      >
        <div>
          <div>
            <div>
              <div>Field Name</div>
              <div>Type</div>
              <div>Show In</div>
            </div>
            <div></div>
          </div>
        </div>
        <div className="scrollable">
          {fieldsToDisplay.map((f, index) => (
            <ItemFieldCardWrapper key={f.key} field={f} index={index} />
          ))}
        </div>
      </ModalGroup>
    </ModalGroups>
  );
};
